import {
  List,
  ListItem,
  ListItemButton,
  useTheme
} from "@mui/material";
import { useEffect, useMemo, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import uniqid from "uniqid";
import useOnClickOutside from "use-onclickoutside";
import { AppConfig } from "../../Config/app-config";
import { ChatbotConsoleService } from "../../Services/Apis/ChatbotConsoleService";
import { getProjectConfigFn } from "../../Services/Apis/CoreApis";
import { CORE_ENDPOINTS } from "../../Services/Apis/Endpoints";
import { useAppSelector } from "../../Store";
import { useAuthStore } from "../../Store/Slices/AuthSlice";
import {
  ChangeSelectedBot,
  useCurrentBot,
} from "../../Store/Slices/DashboardSlices";
import { formatString, isEmptyObject } from "../../Utils";
import {
  detectIdPlaceholder,
  getSelectedMenuObject,
} from "../../Utils/menuUtils";
import { LeftMenuWrap, MenuStyles } from "./MenuStyle";
import { theme } from "../../Customization/Theme";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
// import logo from "../../assets/images/wabo_circle_v2.svg";
import getPublicAssets from "../../Services/s3bucket";
import { domainDetails } from "../../Store/Slices/SubAccount/subaccount.selectors";
// const logo = getPublicAssets("icons/wabo_circle_v2.svg");


const LeftMenu = (props: any): JSX.Element => {
  const theme=useTheme();
  let navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const currentBot = useAppSelector(useCurrentBot);
  const { userConfig }: any = useAppSelector(useAuthStore);
  const isWhatsappConfigured = userConfig?.payload?.whatsapp_enabled ?? false;
  var [selectedIndex, setSelectedIndex] = useState<any>("");
  var [renderSubMenu, setRenderSubMenu] = useState<any>("");
  var [renderMoreSectionMenu, setRenderMoreSectionMenu] =
    useState<boolean>(false);
  var [parentId, setParentId] = useState<string>("");
  const workspace_id: string = window.localStorage.getItem("ws_id") || "";
  const domainDetailsData=useAppSelector(domainDetails);

  

  const getBotDataIfExitsInUrl = () => {
    const botId = AppConfig.getLoggedInData()?.data?.user.bots[0];
    botId &&
      !currentBot?.bot_id &&
      ChatbotConsoleService.getBotById({ bot_id: botId }).then((response) => {
        const bot = response.data;
        dispatch(ChangeSelectedBot(response.data));
        const proj_v_url = formatString(CORE_ENDPOINTS.PROJECT_VER_CONFIG, [
          bot.project_version_id,
        ]);
        getProjectConfigFn(dispatch)({ url: proj_v_url }).then(
          (res: any) => {}
        );
      });
  };

  const getCurrentPathAfterRefresh = () => {
    //* HARDCODING THIS VALUE BECAUSE CHANGING THIS REQUIRES A LOT OF CHANGES IN THE MULTIPLE FILES //
    if (location.pathname.indexOf("/setup") >= 0) {
      getBotDataIfExitsInUrl();
      return setSelectedIndex("setup");
    }
    if (location.pathname.indexOf("/settings") >= 0) {
      return setSelectedIndex("settings");
    }
    if (location.pathname.indexOf("/subscription") >= 0) {
      return setSelectedIndex("subscription");
    }
    if (location.pathname.indexOf("/whatsapp/templates") >= 0 || location.pathname.indexOf("/whatsapp/default_template") >= 0) {
      return setSelectedIndex("templates");
    }
    if (location.pathname.indexOf("/whatsapp/flow") >= 0) {
      return setSelectedIndex("whatsapp-flow");
    }

    let SelectedMenu = getSelectedMenuObject(
      userConfig?.payload?.menu_items?.left_top_menu_options,
      location.pathname
    );

    if (!SelectedMenu) {
      SelectedMenu = getSelectedMenuObject(
        userConfig?.payload?.menu_items?.left_bottom_menu_options,
        location.pathname
      );
    }

    if (SelectedMenu) {
      setSelectedIndex(SelectedMenu?.value);
    }
  };

  const memoizedTopMenuOptions = useMemo(() => {
    const permissionsData: any =
      userConfig?.payload?.allowed_permissions ?? null;
    if (isEmptyObject(permissionsData)) return;

    const result = userConfig?.payload?.menu_items?.left_top_menu_options ?? [];

    return result;
  }, [userConfig?.payload?.menu_items?.left_top_menu_options]); // eslint-disable-line react-hooks/exhaustive-deps


  useEffect(() => {
    getCurrentPathAfterRefresh();
  }, [memoizedTopMenuOptions, location.pathname]); // eslint-disable-line react-hooks/exhaustive-deps

  const handleListItemClick = (curElem: any) => {
    setParentId(curElem.value);

    if (curElem?.children?.length > 0) {
      setRenderSubMenu(true);
      return;
    }

    if (curElem?.value === "setup") {
      const subUrl = `/workspace/{0}/setup/bots`;

      const url = formatString(subUrl, [workspace_id]);
      navigate(url);
      return;
    }

    renderSubMenu && setRenderSubMenu(false);
    const subUrl = curElem?.url;
    navigate(subUrl);

    if (renderMoreSectionMenu || renderSubMenu) {
      closeMenu();
    }
  };

  const handleChildrenItemClick = (curElem: any, parent: any) => {
    setRenderSubMenu(curElem?.value);

    const subUrl = curElem.url;
    navigate(subUrl);
    closeMenu();
  };

  const redirectToHome = () => {
    // const subUrl = "/analytics/dashboard";
    // const subUrl = "/";
    // navigate(subUrl);

    const whatsappConfigured = userConfig?.payload?.whatsapp_enabled ?? false;
    if (whatsappConfigured) { 
      navigate("/");      
    } else {
      navigate("/onboarding/welcome", { replace: true });
    }
  };

  const closeMenu = () => {
    setRenderSubMenu(false);
    setRenderMoreSectionMenu(false);
  };

  const ref = useRef(null);
  useOnClickOutside(ref, closeMenu);

  const accountType=userConfig?.payload.sub_account_type||"";

  const businessLogo=domainDetailsData?.image

  const brandLogo=!accountType?getPublicAssets("icons/wabo_circle_v2.svg"):businessLogo||getPublicAssets("icons/Bot.svg") ;

  return (
    <LeftMenuWrap className="leftMenuWrapper">
        <div className="logoBox">
          <img loading="lazy" src={brandLogo} onClick={() => redirectToHome()} alt="logo"/>
        </div>
      <List
      style={{opacity: isWhatsappConfigured ? 1 : 0.5, }}
      >

        {memoizedTopMenuOptions &&
          memoizedTopMenuOptions.length > 0 &&
          memoizedTopMenuOptions
            ?.slice(0, 6)
            ?.map((curElem: any, index: number) => {
              if (!curElem?.isAvailable) return null;
              return (
                <ListItem key={index} className="menuItem">
                    <ListItemButton
                      key={index}
                      selected={selectedIndex === curElem.value}
                      onClick={(event) => {
                        event.preventDefault(); // This will prevent the link from navigating
                        handleListItemClick(curElem);
                      }}
                      disabled={!isWhatsappConfigured ?? curElem?.isDisabled}
                      component={Link}
                      to={
                        detectIdPlaceholder(curElem?.url)
                          ? formatString(curElem?.url, [workspace_id])
                          : curElem?.url
                      }
                      sx={{
                        textAlign: "center",
                        "&:hover": {
                          background: theme.palette.primary.dark,
                        },
                        "&.Mui-selected": {
                          backgroundColor: theme.palette.primary.dark, // Change the background color when selected
                          "&:hover": {
                            backgroundColor: theme.palette.primary.dark, // Change the background color on hover for selected items
                          },
                        },
                      }}
                      className="menuButton"
                      disableRipple
                    >
                    <img
                        loading="lazy"
                        alt="img_menu"
                        style={{ width: "20px", height: "20px" }}
                        src={curElem?.icon ?? "null"}
                      />
                      <p className="anchor-text">{curElem?.label}</p>
                    </ListItemButton>
                  {renderSubMenu &&
                  parentId === curElem?.value &&
                  curElem?.children?.length ? (
                    <MenuStyles ref={ref}>
                      {curElem?.children?.map((child: any) => {
                        if (!child?.isAvailable) return null;
                        return (
                          <ListItemButton
                            key={uniqid()}
                            className="listItem"
                            selected={
                              location?.pathname?.includes(child?.url)
                            }
                            onClick={(event) => {
                              event.preventDefault(); // This will prevent the link from navigating
                              handleChildrenItemClick(child, curElem);
                            }}
                            disabled={child.isDisabled}
                            component={Link}
                            to={child?.url}
                            sx={{
                              textAlign: "center",
                              "&:hover": {
                                background: theme.palette.primary.dark,
                              },
                              "&.Mui-selected": {
                                backgroundColor: theme.palette.primary.dark, // Change the background color when selected
                                "&:hover": {
                                  backgroundColor: theme.palette.primary.dark, // Change the background color on hover for selected items
                                },
                              },
                            }}
                          >
                            {child?.icon ? (
                              <img
                                loading="lazy"
                                style={{
                                  height: "18px",
                                  width: "18px",
                                  margin: "0px 10px 0 4px",
                                }}
                                src={child?.icon}
                                alt={child?.label}
                              />
                            ) : null}
                            {child?.label}
                          </ListItemButton>
                        );
                      })}
                    </MenuStyles>
                  ) : null}
                </ListItem>
              );
            })}
{memoizedTopMenuOptions && memoizedTopMenuOptions.length > 5 && (
  <>
    <ListItem key={"more-btn"} className="menuItem">
      {/* Check if there is any available child in the slice from index 6 to 12 */}
      {memoizedTopMenuOptions
        .slice(6, 12)
        .some((child: any) => child?.isAvailable) && (
        <ListItemButton
          sx={{
            textAlign: "center",
            "&:hover": {
              background: theme.palette.primary.dark,
            },
            "&.Mui-selected": {
              backgroundColor: theme.palette.primary.dark, // Change the background color when selected
              "&:hover": {
                backgroundColor: theme.palette.primary.dark, // Change the background color on hover for selected items
              },
            },
          }}
          className="menuButton"
          disableRipple
          onClick={() => 
            setRenderMoreSectionMenu(!renderMoreSectionMenu)
          }
          disabled={!isWhatsappConfigured}
        >
          <MoreHorizIcon />
        </ListItemButton>
      )}
      {renderMoreSectionMenu && memoizedTopMenuOptions.length > 0 && (
        <MenuStyles ref={ref}>
          {memoizedTopMenuOptions?.slice(6,12)?.map((child: any, index: number) => {
            if (!child?.isAvailable) return null;

            return (
              <ListItemButton
                key={uniqid()}
                className="listItem"
                selected={
                  location?.pathname?.includes(child?.url)
                }

                onClick={(event) => {
                  event.preventDefault(); // This will prevent the link from navigating
                  handleListItemClick(child);
                }}
                disabled={child.isDisabled ?? !isWhatsappConfigured}
                component={Link}
                to={child?.url}
                sx={{
                  textAlign: "center",
                  "&:hover": {
                    background: theme.palette.primary.dark,
                  },
                  "&.Mui-selected": {
                    backgroundColor: theme.palette.primary.dark, // Change the background color when selected
                    "&:hover": {
                      backgroundColor: theme.palette.primary.dark, // Change the background color on hover for selected items
                    },
                  },
                }}
              >
                {child?.icon ? (
                  <img
                    loading="lazy"
                    style={{
                      height: "18px",
                      width: "18px",
                      margin: "0px 10px 0 4px",
                    }}
                    src={child?.icon}
                    alt={child?.label}
                  />
                ) : null}
                {child?.label}
              </ListItemButton>
            );
          })}
        </MenuStyles>
      )}
    </ListItem>
  </>
)}
      </List>
    </LeftMenuWrap>
  );
};

export default LeftMenu;
